<template>
  <footer class="footer px-4">
    <b-row align-v="center" class="justify-content-lg-between">
      <b-col lg="6">
        <div class="copyright text-center text-lg-left text-muted">
          © {{year}} <a href="https://www.creative-tim.com" class="font-weight-bold ml-1" target="_blank">A&G Ajustadores y Peritos de Seguros</a>
        </div>
      </b-col>
      <b-col lg="6">
        <b-nav align="center" class="nav-footer justify-content-lg-end">
          <!-- <b-nav-item href="https://www.aygajustadores.com"  target="_blank">
           A&G Ajustadores y Peritos de Seguros S.A.C
          </b-nav-item> -->  
          <b-nav-item href="#" target="_blank">
           Sobre Nosotros
          </b-nav-item>
          <b-nav-item href="#" target="_blank">
            LinkedIN 
          </b-nav-item>
          <!-- <b-nav-item href="https://www.creative-tim.com/license" target="_blank">
            License
          </b-nav-item> -->
        </b-nav>
      </b-col>
    </b-row>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style></style>